// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.leadmanagement.type.SatelliteRenterProgressBarStepStatusType

export enum SatelliteRenterProgressBarStepStatusType {
  CHECKED = 'CHECKED',
  DOTTED = 'DOTTED',
  EMPTY = 'EMPTY',
}

export const SatelliteRenterProgressBarStepStatusType_values = [
  SatelliteRenterProgressBarStepStatusType.CHECKED,
  SatelliteRenterProgressBarStepStatusType.DOTTED,
  SatelliteRenterProgressBarStepStatusType.EMPTY,
] as const;
